import React from 'react';

const Footer = () => {
    return (
        <footer>
            <div className="text-center pt-5 pb-3">
            <small>©2021.<span style={{color: '#6047EC',fontSize:'20px'}}>shakilahmed</span>5161@gmail.com All rights reserved. Dhaka, Bangladesh.</small>
        </div>
        </footer>
    );
};

export default Footer;